import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { AppConstants } from "@core/constants/app";
import dayjs from "dayjs";
import { Params } from "@angular/router";

@Injectable({
    providedIn: "root",
})
export class ApplicationConfigService {
    private subject = new BehaviorSubject({
        applicationId: null,
        requestedEffectiveDate: null,
        marketingId: "",
        revision: null,
    });
    private readonly applicationConfig$: Observable<Params>;

    constructor() {
        this.applicationConfig$ = this.subject.asObservable();
    }

    setConfig(applicationId: number, requestedEffectiveDate: string, revision: string | null = null) {
        const effectiveDateMoment = dayjs(requestedEffectiveDate);
        this.subject.next({
            applicationId,
            requestedEffectiveDate,
            marketingId: effectiveDateMoment.isValid() ? AppConstants.APPLICATION_MATERIAL_IDS[effectiveDateMoment.year()] : "",
            revision,
        });
    }

    clearConfig() {
        this.subject.next({
            applicationId: null,
            requestedEffectiveDate: null,
            marketingId: "",
            revision: null,
        });
    }

    getConfig(): Observable<Params> {
        return this.applicationConfig$;
    }
}
